<mat-form-field class="w-full" appearance="fill">
  <mat-label>{{ templateTag?.displayName }}</mat-label>
  <input matInput [placeholder]="templateTag?.displayName || ''" [formControl]="dataUpcast" [matDatepicker]="picker" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
